import { onCLS, onFCP, onLCP, onTTFB, onINP, type Metric } from 'web-vitals';
import { logger } from './logger';
import { env } from '../config/env';

/**
 * Report a single Core Web Vital metric.
 * In development: logs to console for immediate feedback.
 * In production/staging/qa: logs via structured logger.
 */
function reportMetric(metric: Metric): void {
  const metricData = {
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    id: metric.id,
  };

  if (env.environment === 'development') {
    console.log(`[Web Vitals] ${metric.name}:`, metricData);
  } else {
    logger.info(`Core Web Vital: ${metric.name}`, metricData);
  }
}

/**
 * Reports Core Web Vitals (CLS, FCP, LCP, TTFB, INP) using web-vitals library.
 *
 * In production/staging: logs metrics via logger (analytics endpoint deferred).
 * In development: logs to console only.
 *
 * Metrics reported:
 * - CLS (Cumulative Layout Shift): Visual stability
 * - FCP (First Contentful Paint): Time to first render
 * - LCP (Largest Contentful Paint): Loading performance
 * - TTFB (Time to First Byte): Server response time
 * - INP (Interaction to Next Paint): Responsiveness
 */
export function reportWebVitals(): void {
  onCLS(reportMetric);
  onFCP(reportMetric);
  onLCP(reportMetric);
  onTTFB(reportMetric);
  onINP(reportMetric);
}
